import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: window._env_?.AZURE_AD_CLIENT_ID || "",
    authority: `https://login.microsoftonline.com/${window._env_?.AZURE_AD_TENANT_ID || ""}`,
    redirectUri: window.location.origin + "/",
  },
  cache: {
    cacheLocation: "sessionStorage" as const,
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
export const API_SCOPE = `api://${window._env_?.AZURE_AD_CLIENT_ID}/access_as_user`;
